import { indexItems } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-4 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            专题合集
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            快速找到你想看的
          </h2>
          <p className="mt-2 text-sm text-foreground-600">多种方式索引，总有一种适合你</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <div key={item.id} className="bg-background-100 rounded-xl p-5 flex items-start gap-4 group cursor-pointer hover:bg-background-200/70 transition-colors">
              <div className="w-10 h-10 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-600 text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-semibold text-foreground-950">{item.title}</h3>
                <span className="text-xs text-primary-600 font-medium">{item.count}</span>
                <p className="mt-1 text-xs text-foreground-600 leading-relaxed">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}